<app-info-page title="Información de interés">
  <main class="screen__content">
    <div *ngFor="let category of getUniqueCategories()">
      <section class="section-header">
        {{ category }}
      </section>
      <section class="cards">
        <div *ngFor="let action of getActionsByCategory(category)">
          <div class="card__name">
            {{ action.name }}
          </div>
          <button
            type="button"
            class="card__call"
            (click)="call(action.phone)"
          >
            <span class="card__call-icon"><i class="fas fa-phone"></i></span>
            <span class="card__call-text">Llamar</span>
          </button>

        </div>
      </section>
    </div>
  </main>
</app-info-page>
